import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '../../../app.service';
import { SafetyInductionService } from '../services/safety-induction.service';
import { InductionQuestionsListVM } from '../setup-induction-question/setup-induction-question';
import { DialogAddSlideComponent } from './component/dialog-add-slide/dialog-add-slide.component';
import { TogleSlideVM } from './setup-induction-slides';

@Component({
  selector: 'app-setup-induction-slides',
  templateUrl: './setup-induction-slides.component.html',

  styleUrls: ['./setup-induction-slides.component.css']
})
export class SetupInductionSlidesComponent implements OnInit {

  selectedCategory:number=1;
  selectedOption:any;
  option1:any;
  option2:any;
  SetupInductionQuestion: InductionQuestionsListVM;
  loading:boolean=false;
  constructor(
    public dialog: MatDialog,
    private _router:Router,
    private route: ActivatedRoute,
    private _appService: AppService,
    private _inductionService: SafetyInductionService,
  ) { }

  ngOnInit() {
    this._appService.setPageTitle('Setup Induction Slides');
   // this._appService.setPageSubTitle('');
    this.SetupQuestions(this.selectedCategory)
  }

  changeInductionCategory(ID){
    this.SetupQuestions(ID)
  }

  onClickEditSlide(slide){
    console.log("slide",slide)
    const dialogRef = this.dialog.open(DialogAddSlideComponent, {
      disableClose: true,
      panelClass: 'removeModalOverflow',
      minWidth: '800px',
      minHeight: '500px',

      data: {
        slide:slide,
         edit:true
      }

    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == true) {
        this.SetupQuestions(this.selectedCategory)
      } else if (result == false) {

        console.log('The dialog was closed');
      }
    });
  }

  openAddSlideDialog(section){
    console.log("section",section)
    const dialogRef = this.dialog.open(DialogAddSlideComponent, {
      disableClose: true,
      panelClass: 'removeModalOverflow',
      minWidth: '800px',
      minHeight: '500px',

      data: {
          SectionID:section.ID,
         edit:false
      }

    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == true) {
        this.SetupQuestions(this.selectedCategory)
      } else if (result == false) {

        console.log('The dialog was closed');
      }
    });
  }

  

  SectionUp(sectionID:number, Order:number){
    this._inductionService.OrderUp_InductionSlide(sectionID, Order).subscribe(res=>{
      if(res){
      
        this._inductionService.SetupQuestions(this.selectedCategory).subscribe(res => {
          console.log("SetupQuestions", res)
          if (res.m_Item1) {
            let arr :InductionQuestionsListVM
            arr = res.m_Item2;
    
            arr.Selections.map(s=>{
              let slides_ = arr.Slides.filter(slide=>slide.SlideSelectionId == s.ID && slide.Active == true )
              console.log("slides_ SectionUp",slides_)
              var byOrder = slides_.slice(0);
              byOrder.sort(function(a,b) {
                  var x = a.Order
                  var y = b.Order
                  return x < y ? -1 : x > y ? 1 : 0;
              });

              console.log("byOrder SectionUp",byOrder)

              s.Slides = byOrder
            })
    
            this.SetupInductionQuestion = arr;
          }
          // this.categories=res.InductionTypes;
          //this.questions=res.Selections;
          this.loading=false
        })
      }
    })
    }
    
    SectionDown(sectionID:number, Order:number){
      this._inductionService.OrderDown_InductionSlide(sectionID, Order).subscribe(res=>{
        if(res){
          this._inductionService.SetupQuestions(this.selectedCategory).subscribe(res => {
            console.log("SetupQuestions", res)
            if (res.m_Item1) {
              let arr :InductionQuestionsListVM
              arr = res.m_Item2;
      
              arr.Selections.map(s=>{
                let slides_ = arr.Slides.filter(slide=>slide.SlideSelectionId == s.ID && slide.Active == true )
                console.log("slides_ SectionDown",slides_)
                var byOrder = slides_.slice(0);
                byOrder.sort(function(a,b) {
                    var x = a.Order
                    var y = b.Order
                    return x < y ? -1 : x > y ? 1 : 0;
                });

                console.log("byOrder SectionDown",byOrder)

                s.Slides = byOrder
              })
      
              this.SetupInductionQuestion = arr;
            }
            // this.categories=res.InductionTypes;
            //this.questions=res.Selections;
            this.loading=false
          })
        }
      })
    }

  clickQuestionenableDisable(slide){
    let params = new TogleSlideVM();
    params.slideId = slide.ID;
    params.active = slide.Active == true?false:true;

    this._inductionService.ToggleSlide(params).subscribe(res => {
      console.log("ToggleSlide", res)
      if (res.m_Item1) {
        this.SetupQuestions(this.selectedCategory)

      }
      // this.categories=res.InductionTypes;
      //this.questions=res.Selections;
    })
  }

  SetupQuestions(ID: number) {
    this.loading=true
    this._inductionService.SetupQuestions(ID).subscribe(res => {
      console.log("SetupQuestions", res)
      if (res.m_Item1) {
        let arr :InductionQuestionsListVM
        arr = res.m_Item2;

        arr.Selections.map(s=>{
          let slides_ = arr.Slides.filter(slide=>slide.SlideSelectionId == s.ID && slide.Active == true )
          var byOrder = slides_.slice(0);
          byOrder.sort(function(a,b) {
              var x = a.Order
              var y = b.Order
              return x < y ? -1 : x > y ? 1 : 0;
          });
          s.Slides = byOrder
        })

        this.SetupInductionQuestion = arr;
      }
      // this.categories=res.InductionTypes;
      //this.questions=res.Selections;
      this.loading=false
    })
  }

  OpenSafetyInductionSetup(){
    console.log("select option",this.selectedOption);
    if(this.selectedOption == this.option1)
    {
      this._router.navigate(['safety'],{relativeTo:this.route});

    }else if(this.selectedOption == this.option2)
    {

    }
  }
}
